<script lang="ts">
	import type { DatasheetPoiData } from '../types';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';
	import { getSponsorConfigByPoi, isAnyPoiPartner } from '$lib/constants/sponsoredPoi';
	import { createEventDispatcher } from 'svelte';
	import DatasheetDetail from './detail/DatasheetDetail.svelte';
	import DatasheetHighlight from './highlight/DatasheetHighlight.svelte';

	const dispatch = createEventDispatcher<{ handleClick: void }>();

	export let poi: DatasheetPoiData;
	export let isCollapsed: boolean;
	export let datasheetHighlightContainer: HTMLDivElement | undefined;

	$: brandLogoUrl = isAnyPoiPartner(poi) ? getSponsorConfigByPoi(poi)?.datasheet.brandLogoUrl : undefined;
	$: removeHightEmptyContainerClasses = isAnyPoiPartner(poi) ? 'absolute' : '';
</script>

<button
	type="button"
	class="snap-handle py-2 rd-2 b-0 flex justify-self-center justify-center bg-transparent md:hidden"
	on:click={() => dispatch('handleClick')}
>
	<span class="rd-1 w-8 h-1 bg-base-15" />
</button>
<div class="flex items-start justify-between md:mt-4 relative">
	<div
		class="snap-end clamp-lines-2 text-title px-2"
		data-testId="datasheet-title"
		class:mr-18={isAnyPoiPartner(poi) && brandLogoUrl}
	>
		{poi.name}
	</div>
	{#if isAnyPoiPartner(poi) && brandLogoUrl}
		<Image src={brandLogoUrl} class="w-16 ml-1 top--4 absolute right-1" alt={poi.name || ''} />
	{/if}
	{#if poi.__typename === 'AccommodationPOI' && poi.stars !== null}
		<div class="flex text-5 text-hotel h-8 items-center">
			<RepeatIcons icon="grade" amount={poi.stars} style="grade" />
		</div>
	{/if}
</div>
<div class="flex flex-col w-full gap-6 mb-6 {poi.__typename === 'ServiceRestStopPOI' && poi.facilities && poi.facilities.length > 0 ? '' : 'px-2'}">
	<div
		class="snap-end {removeHightEmptyContainerClasses}"
		bind:this={datasheetHighlightContainer}
	>
		<DatasheetHighlight displayPicture={isCollapsed} {poi} />
	</div>
	<div class="flex flex-col gap-6 snap-map-button">
		<DatasheetDetail {poi} on:seeOnMap on:itineraryClick on:learnMoreClick />
	</div>
</div>

<style>
	.snap-handle {
		scroll-snap-align: start;
	}

	.snap-map-button {
		scroll-snap-align: start;
		scroll-margin: 68px;
	}

	.snap-end {
		scroll-snap-align: end;
		scroll-margin: 68px;
	}
</style>
